module.exports = __webpack_public_path__ + "img/29-SpendAlerts.236eff19.jpg";